import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex items-start gap-4',
    imageWrapper: 'relative aspect-3/4 h-25 shrink-0',
    image: 'size-full object-cover',
    content: 'flex min-w-0 flex-1 flex-col gap-2',
    title: 'heading-m-regular w-full truncate',
    price: 'flex flex-wrap items-end gap-2.5',
    priceValue: 'heading-m',
    oldPrice: 'text-tertiary heading-xs pb-0.5 line-through',
    discount: 'text-error heading-xs pb-0.5'
  },
  variants: {},
  defaultVariants: {}
});
